import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('ice_cavern', {
  cherry: 'ice_pick',
  lemon: 'miner_lantern',
  orange: 'amber_crystal',
  bell: 'frost_bell',
  star: 'crystal_wild',
  seven: 'blue_geode',
  gem: 'frozen_diamond',
  scatter: 'icicle_scatter',
  money: 'crystal_hoard',
});

/** Ice Cavern — GENERATED by scaffoldSlot from
 *  content/slots/ice_cavern.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const ICE_CAVERN_THEME: Theme = {
  id: 'ice_cavern',
  name: 'Ice Cavern',
  palette: {
    accent: 0x4fb0c8,
    secondary: 0xa9dbe8,
    warm: 0xf2d27a,
    frameFill: 0x16242c,
    bgGradientTop: 0x244049,
    bgGradientBottom: 0x0a161b,
    dimOverlay: 0x050d11,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Ice Pick', glyph: '⛏️', tint: 0x8a96a3, weight: 5, textureAlias: 'ice_cavern:cherry',
        winVideoAlias: 'ice_cavern:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Lantern', glyph: '🏮', tint: 0xe0a83a, weight: 5, textureAlias: 'ice_cavern:lemon',
        winVideoAlias: 'ice_cavern:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Amber Crystal', glyph: '🔶', tint: 0xd9852f, weight: 4, textureAlias: 'ice_cavern:orange',
        winVideoAlias: 'ice_cavern:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Frost Bell', glyph: '🔔', tint: 0xc8d6e0, weight: 3, textureAlias: 'ice_cavern:bell',
        winVideoAlias: 'ice_cavern:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Ice Crystal', glyph: '💠', tint: 0x4fd0d8, weight: 2, textureAlias: 'ice_cavern:star',
        winVideoAlias: 'ice_cavern:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Geode', glyph: '🔷', tint: 0x5a8fc0, weight: 2, textureAlias: 'ice_cavern:seven',
        winVideoAlias: 'ice_cavern:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Frozen Diamond', glyph: '💎', tint: 0xdfeff7, weight: 2.5, textureAlias: 'ice_cavern:gem',
        winVideoAlias: 'ice_cavern:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Icicles', glyph: '🧊', tint: 0xbfe0ef, weight: 0.5, textureAlias: 'ice_cavern:scatter',
        winVideoAlias: 'ice_cavern:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Crystal Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'ice_cavern:money',
        winVideoAlias: 'ice_cavern:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x16242c, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x4fb0c8, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xa9dbe8, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x4fb0c8, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x16242c, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xa9dbe8, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x4fb0c8, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'ice_cavern:bg', path: 'environment/ice_cavern.png' },
      columnBackground: { alias: 'ice_cavern:column_bg', path: 'reel/ice_cavern_column_bg.png' },
      border: { alias: 'ice_cavern:border', path: 'brand/border_frost.png' },
    },
  },
};
